module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-300italic.woff?3ab0502d6136886180cdae3e714e30a3";